class LiteEvent {
    constructor() {
        this.handlers = [];
    }
    on(handler) {
        this.handlers.push(handler);
    }
    off(handler) {
        this.handlers = this.handlers.filter(h => h !== handler);
    }
    trigger(data) {
        this.handlers.slice(0).forEach(h => h(data));
    }
    expose() {
        return this;
    }
}
class TableEvents {
    constructor() {
        this.clearForm = new LiteEvent();
        this.openModal = new LiteEvent();
        this.closeModal = new LiteEvent();
        this.updateGrid = new LiteEvent();
    }
    get ClearForm() { return this.clearForm.expose(); }
    clearFormEvt() {
        this.clearForm.trigger();
    }
    get OpenModal() { return this.openModal.expose(); }
    openModalEvt() {
        this.openModal.trigger();
    }
    get CloseModal() { return this.closeModal.expose(); }
    closeModalEvt() {
        this.closeModal.trigger();
    }
    get UpdateGrid() { return this.updateGrid.expose(); }
    updateGridEvt() {
        this.updateGrid.trigger();
    }
}
export { TableEvents };
//# sourceMappingURL=LiteEvents.js.map